import BrTable from './BrTable';
import BrColumn from './BrColumn';
import * as Columns from './columns';

BrTable.Columns = Columns;
BrTable.BrColumn = BrColumn;
export default BrTable;
